import { postForm, postJson, toFormData } from "../../utils/utils";
import { entitiesActions } from "./entities-slice";
import { errorHandlingActions } from "./error-handling-slice";
import toolLevelType from "../../enums/toolLevelType";
import entitysType from "../../enums/entitysType";
import tags from "../../enums/tags";

const normalizeToolEntity = (tool, fallbackSchoolId) => ({
    ...tool,
    name: { he: tool.name, ar: tool.name },
    link: tool.url,
    imageUrl: tool.iconUrl,
    targetAudience: tool.targetAudience ?? tool.targetGroupId,
    visibleTo: tool.targetGroupId,
    gradeMask: tool.gradeMask ?? 0,
    type: entitysType.usefulTool,
    externalId: tool.toolId ?? tool.externalId,
    schoolId: tool.schoolId ?? fallbackSchoolId,
    studyGroupId: tool.studyGroupId,
    toolLevel: tool.toolLevel ?? toolLevelType.School,
    ownerId: tool.ownerId,
    sourceTypeId: tool.sourceTypeId,
    targetGroupId: tool.targetGroupId,
    providerName: "api",
    endpoints: [entitysType.usefulTool],
    tags: [tags.addedByUser],
});


export const saveToolThunk = (formData) => async (dispatch, getState) => {
    try {
        const schoolId = getState().auth.userDetails?.defaultSchool?.id;
        if (schoolId && !formData.get('schoolId'))
            formData.append('schoolId', schoolId);

        const result = await postForm(
            `${window.config.baseApiUrl}/api/tool/addOrUpdate`,
            formData
        );
        if (result?.ok && result.body) {
            const normalizedEntity = normalizeToolEntity(result.body, schoolId);

            if (formData.get('toolId')) {
                dispatch(entitiesActions.updateEntity({
                    entityId: result.body.toolId,
                    entityType: entitysType.usefulTool,
                    updates: normalizedEntity,
                }));
            } else {
                dispatch(entitiesActions.addEntities([normalizedEntity]));
            }
            return result.body;
        }
        const { texts } = getState().translate;
        dispatch(errorHandlingActions.throwError({ userMessage: texts.saveFailed, level: 2 }));
        return null;
    } catch (e) {
        console.error("error saveToolThunk", e);
        const { texts } = getState().translate;
        dispatch(errorHandlingActions.throwError({ userMessage: texts.saveFailed, level: 2 }));
        return null;
    }
};

export const deleteToolThunk = (tool) => async (dispatch, getState) => {
    try {
        const schoolId = getState().auth.userDetails?.defaultSchool?.id;
        const targetGroupId = tool.targetAudience ?? tool.visibleTo ?? tool.targetGroupId;
        const payload = toFormData({
            name: tool.name,
            url: tool.url || tool.link || "",
            isEnabled: false,
            schoolId,
            toolLevel: tool.toolLevel,
            studyGroupId: tool.studyGroupId,
            sourceTypeId: tool.sourceTypeId,
            targetGroupId,
            ...(tool.toolId
                ? { toolId: tool.toolId }
                : { externalId: String(tool.externalId ?? tool.id ?? ""), isOverride: true }),
        });
        const savedTool = await dispatch(saveToolThunk(payload));
        if (savedTool) {
            dispatch(entitiesActions.deleteEntity({
                entityId: tool.toolId ?? tool.externalId ?? tool.id,
                entityType: tool.type ?? entitysType.usefulTool,
            }));
        }
        return !!savedTool;
    } catch (e) {
        console.error("error deleteToolThunk", e);
        return false;
    }
};

export const fetchSchoolToolsThunk = (schoolId) => async (dispatch) => {
    try {
        const tools = await postJson(`${window.config.baseApiUrl}/api/tool/filterRange`, { schoolId });
        if (tools?.body?.length)
            dispatch(entitiesActions.addEntities(tools.body.map(t => normalizeToolEntity(t, schoolId))));
    } catch (e) {
        console.error("error fetchSchoolToolsThunk", e);
    }
};